export const FEATURE_KEYS = {
  DUBBING: 'dubbing',
  RECAPTCHA_TRY_LISTEN_TTS_TYPE: 'recaptcha-try-listen-tts-type',
  RECAPTCHA_TTS_TYPE: 'recaptcha-tts-type',
  TRY_LISTEN_TTS: 'try-listen-tts',
  DUBBING_BY_UNIT_SECOND: 'dubbing-by-unit-second',
  MULTIPLE_INPUT_DUBBING: 'multiple-input-dubbing',
  VOICE_CLONING: 'voice-cloning',
  STREAMING_PREVIEW: 'streaming-preview',
  DUBBING_SUBTITLE_TIMELINE: 'dubbing-subtitle-timeline',
  AUTO_RENEW_MOMO: 'auto-renew-momo', // Use auto-renew with momo
  DUBBING_PROJECTS: 'dubbing-projects',
  MULTIPLE_LANGUAGES_SRT: 'multiple-languages-srt',
  VIEW_VIDEO_WITH_TIMELINE: 'view-video-with-timeline',
  STT: 'stt',
  VC_NEW_RECORDING: 'vc-new-recording',
  SUGGEST_DICTIONARY: 'suggest-dictionary',
  VOICE_CREDITS_BY_LEVEL: 'voice-credits-by-level',
  PROMOTED_PACKAGE_MOE: 'promoted-package-moe',
  SYNC_AFFILIATE_MARKETER: 'sync-affiliate-marketer',
  SENTRY_AIVOICE_WEB_APP: 'sentry-aivoice-web-app',
  NON_VBEE_BREAK_TIME: 'non-vbee-break-time',
  VNPAY_DISCOUNT_INFO: 'vnpay-discount-info',
  MULTILINGUAL_VOICE: 'multilingual-voice',
  USE_USAGE_OPTIONS_IN_PACKAGE: 'use-usage-options-in-package',
  PAYMENT_QR_V2: 'payment-qr-v2',
  SIGNUP_SURVEY: 'signup-survey',
  SPLIT_PARAGRAPH: 'split-paragraph',
  VOICE_HAS_BEEN_RENAMED: 'voice-has-been-renamed',
  PUSH_EVENT_TO_GTM_SERVER: 'push-event-to-gtm-server',
  NOTE_INFO_PACKAGE: 'note-info-package',
  EMAIL_REQUIRED: 'email-required',
  LIMIT_FREE_USER_PROJECTS: 'limit-free-user-projects',
  DATADOG_AIVOICE_WEB_APP: 'datadog-aivoice-web-app',
  TRIAL_VOICE_CONFIG: 'trial-voice-config',
  NOTIFY_NEAR_EXPIRY: 'notify-near-expiry',
  TIPS_CREATE_VOICE: 'tips-create-voice',
  MAPPING_PACKAGE_CODES: 'mapping-package-codes',
  CLOUDFLARE_TURNSTILE_AIVOICE: 'cloudflare-turnstile-aivoice',
  CAPTCHA_PROVIDER_AIVOICE: 'captcha-provider-aivoice',
  ONBOARDING_POPUP: 'onboarding-popup',
  BLOCK_WITH_DUBBING_PROJECT: 'block-with-dubbing-project',
  CREATE_SRT_PROJECT: 'create-srt-project',
  PROJECT_DUBBING_EDIT_TIME_BLOCK: 'project-dubbing-edit-time-block',
  SPEAKER_CONFIG: 'speaker-config',
  DOWNLOAD_FILE_SRT: 'download-file-srt',
  LIST_APPS: 'list-apps',
  IMPROVE_AUDIO_UPLOAD: 'improve-audio-upload',
  AUTO_RENEW_PRICE_ADJUSTMENT: 'auto-renew-price-adjustment',
  NEW_UI_MY_PACKAGE: 'new-ui-my-package',
  INFO_CREDITS_API: 'info-credits-api',
  MERGE_PACKAGE_API_TO_STUDIO: 'merge-package-api-to-studio',
  NEW_UI_ITEM_VOICE_CLONING: 'new-ui-item-voice-cloning',
  STUDIO_TTS_API: 'studio-tts-api',
  DUPLICATE_VOICE: 'duplicate-voice',
  ONBOARDING_AI_PRONUNCIATION_CHECK: 'onboarding-ai-pronunciation-check',
  CREDITS_INTRO: 'credits-intro',
  NEW_PRICING_OVERVIEW: 'new-pricing-overview',
  PACKAGES_COMPARISON: 'packages-comparison',
  USER_VOICE_EOL: 'user-voice-eol',
  PREMIUM_VOICE: 'premium-voice',
  GEN2_VIETNAM_VOICE: 'gen2-vietnam-voice',
  ENABLE_CREDIT_USAGE_PREVIEW: 'enable-credit-usage-preview',
  IMPROVE_AUTO_RENEW_CANCEL_FLOW: 'improve-auto-renew-cancel-flow',
  NOTIFICATION: 'notification',
  AI_PRONUNCIATION_CHECK: 'ai-pronunciation-check',
  SRT_RECOMMENDED_CHARACTER_WARNING: 'srt-recommended-character-warning',
  AI_TRANSLATE: 'ai-translate',
  AI_PRONUNCIATION_CHECK_CREDIT_COST: 'ai-pronunciation-check-credit-cost',
  PROJECT_TTS_IMPROVE_BLOCK_UI: 'project-tts-improve-block-ui',
  NEW_UI_PROJECTS: 'new-ui-projects',
  AI_REWRITE: 'ai-rewrite',
  PRESENTATION_PROJECTS: 'presentation-projects',
  PRESENTATION_LLM: 'presentation-llm',
  PRESENTATION_AI_MODELS: 'presentation-ai-models',
  PRESENTATION_PREVIEW: 'presentation-preview',
  NEW_UI_APP_DETAIL: 'new-ui-app-detail',
  LAUNCH_API_TTS_STT: 'launch-api-tts-stt',
  TRANSLATE_SUPPORTED_LANGUAGES: 'translate-supported-languages',
  PRESENTATION_EXPORT: 'presentation-export',
  WITHDRAWAL_TAX_INFO: 'withdrawal-tax-info',
  STT_SYNC: 'stt-sync',
  STT_ASYNC: 'stt-async',
  STT_STREAMING: 'stt-streaming',
  TTS_SYNC: 'tts-sync',
  TTS_ASYNC: 'tts-async',
  TTS_STREAMING: 'tts-streaming',
  CREDITS_USAGE_GUIDE: 'credits-usage-guide',
  CANCEL_AUTO_RENEW_DIALOG: 'cancel-auto-renew-dialog',
  TRANSCRIPT_AUDIO: 'transcript-audio',
  TRANSCRIPT_AUDIO_MODELS: 'transcript-audio-models',
  VIDEO_DUBBING_PREVIEW: 'video-dubbing-preview',
  VIDEO_DUBBING_PROJECT: 'video-dubbing-project',
  PROJECT_DUBBING_UNDO_REDO: 'project-dubbing-undo-redo',
  PROJECT_DUBBING_INSERT_BLOCK: 'project-dubbing-insert-block',
  VIDEO_DUBBING_ASPECT_RATIO: 'video-dubbing-aspect-ratio',
  VIDEO_DUBBING_BG_COLOR: 'video-dubbing-bg-color',
  PRESENTATION_PROJECT_FEEDBACK: 'presentation-project-feedback',
  PRESENTATION_SLIDE_V2: 'presentation-slide-v2',
  PRESENTATION_EXTRACT_PROGRESS: 'presentation-extract-progress',
  BACKGROUND_MUSIC_POLICY_AGREEMENT: 'background-music-policy-agreement',
  PROJECT_AUTO_SAVE: 'project-auto-save',
  PROJECT_EXPORT_HISTORY: 'project-export-history',
  PRESENTATION_EXPORT_VIDEO: 'presentation-export-video',
  AFFILIATE_PAYMENT_REQUEST_V2: 'affiliate-payment-request-v2',
  BULK_DELETE_PROJECTS: 'bulk-delete-projects',
  VIDEO_DUBBING_SRT_UPLOAD: 'video-dubbing-srt-upload',
  VIDEO_DUBBING_CREATE_AUDIO: 'video-dubbing-create-audio',
  VIDEO_DUBBING_DOWNLOAD_AUDIO: 'video-dubbing-download-audio',
  VIDEO_DUBBING_EXPORT_VIDEO: 'video-dubbing-export-video',
  VIDEO_DUBBING_TIMELINE_TRACKS: 'video-dubbing-timeline-tracks',
  VIDEO_DUBBING_CAPTION: 'video-dubbing-caption',
  VIDEO_DUBBING_CAPTION_KARAOKE: 'video-dubbing-caption-karaoke',
  TRANSCRIBE_CHUNK: 'transcribe-chunk',
  USE_DOWNLOAD_SEPARATE_AUDIO_V2: 'use-download-separate-audio-v2',
  USE_DOWNLOAD_SINGLE_AUDIO_V2: 'use-download-single-audio-v2',
  EDUCATORS_MODE: 'educators-mode',
  EDUCATOR_HOME_VOICES: 'educator-home-voices',
  NEW_VOICE_PRESET_NAME_LENGTH: 'new-voice-preset-name-length',
  TTS_WALLET_FROM_SERVER: 'tts-wallet-from-server',
  TOP_PAID_EVENT: 'event-top-paid',
};
